//#region src/country_subdivision.ts
/**
* Subdivisions (states/provinces/territories) of countries that Bite operates in.
*
* The TypeScript enum keys are namespaced (`Usa*`, `Canada*`) so call sites stay
* unambiguous, but the underlying values are the raw 2-letter codes (`'NY'`,
* `'ON'`) — the same shape that Google's geocoder returns under
* `administrative_area_level_1.short_name`. US and Canadian 2-letter codes are
* disjoint today; if a future country (e.g. Mexico's `BC` for Baja California)
* collides with a Canadian code, we'll need a different storage strategy.
*/
var CountrySubdivision = /* @__PURE__ */ function(CountrySubdivision) {
	CountrySubdivision["UsaAL"] = "AL";
	CountrySubdivision["UsaAK"] = "AK";
	CountrySubdivision["UsaAZ"] = "AZ";
	CountrySubdivision["UsaAR"] = "AR";
	CountrySubdivision["UsaCA"] = "CA";
	CountrySubdivision["UsaCO"] = "CO";
	CountrySubdivision["UsaCT"] = "CT";
	CountrySubdivision["UsaDE"] = "DE";
	CountrySubdivision["UsaFL"] = "FL";
	CountrySubdivision["UsaGA"] = "GA";
	CountrySubdivision["UsaHI"] = "HI";
	CountrySubdivision["UsaID"] = "ID";
	CountrySubdivision["UsaIL"] = "IL";
	CountrySubdivision["UsaIN"] = "IN";
	CountrySubdivision["UsaIA"] = "IA";
	CountrySubdivision["UsaKS"] = "KS";
	CountrySubdivision["UsaKY"] = "KY";
	CountrySubdivision["UsaLA"] = "LA";
	CountrySubdivision["UsaME"] = "ME";
	CountrySubdivision["UsaMD"] = "MD";
	CountrySubdivision["UsaMA"] = "MA";
	CountrySubdivision["UsaMI"] = "MI";
	CountrySubdivision["UsaMN"] = "MN";
	CountrySubdivision["UsaMS"] = "MS";
	CountrySubdivision["UsaMO"] = "MO";
	CountrySubdivision["UsaMT"] = "MT";
	CountrySubdivision["UsaNE"] = "NE";
	CountrySubdivision["UsaNV"] = "NV";
	CountrySubdivision["UsaNH"] = "NH";
	CountrySubdivision["UsaNJ"] = "NJ";
	CountrySubdivision["UsaNM"] = "NM";
	CountrySubdivision["UsaNY"] = "NY";
	CountrySubdivision["UsaNC"] = "NC";
	CountrySubdivision["UsaND"] = "ND";
	CountrySubdivision["UsaOH"] = "OH";
	CountrySubdivision["UsaOK"] = "OK";
	CountrySubdivision["UsaOR"] = "OR";
	CountrySubdivision["UsaPA"] = "PA";
	CountrySubdivision["UsaRI"] = "RI";
	CountrySubdivision["UsaSC"] = "SC";
	CountrySubdivision["UsaSD"] = "SD";
	CountrySubdivision["UsaTN"] = "TN";
	CountrySubdivision["UsaTX"] = "TX";
	CountrySubdivision["UsaUT"] = "UT";
	CountrySubdivision["UsaVT"] = "VT";
	CountrySubdivision["UsaVA"] = "VA";
	CountrySubdivision["UsaWA"] = "WA";
	CountrySubdivision["UsaWV"] = "WV";
	CountrySubdivision["UsaWI"] = "WI";
	CountrySubdivision["UsaWY"] = "WY";
	CountrySubdivision["UsaDC"] = "DC";
	CountrySubdivision["UsaAS"] = "AS";
	CountrySubdivision["UsaGU"] = "GU";
	CountrySubdivision["UsaMP"] = "MP";
	CountrySubdivision["UsaPR"] = "PR";
	CountrySubdivision["UsaVI"] = "VI";
	CountrySubdivision["CanadaAB"] = "AB";
	CountrySubdivision["CanadaBC"] = "BC";
	CountrySubdivision["CanadaMB"] = "MB";
	CountrySubdivision["CanadaNB"] = "NB";
	CountrySubdivision["CanadaNL"] = "NL";
	CountrySubdivision["CanadaNS"] = "NS";
	CountrySubdivision["CanadaON"] = "ON";
	CountrySubdivision["CanadaPE"] = "PE";
	CountrySubdivision["CanadaQC"] = "QC";
	CountrySubdivision["CanadaSK"] = "SK";
	CountrySubdivision["CanadaNT"] = "NT";
	CountrySubdivision["CanadaNU"] = "NU";
	CountrySubdivision["CanadaYT"] = "YT";
	return CountrySubdivision;
}(CountrySubdivision || {});
//#endregion
export { CountrySubdivision };

//# sourceMappingURL=country_subdivision.js.map